import { MantineTheme, createStyles } from "@mantine/styles";

export const useStyle = createStyles((theme: MantineTheme) => ({
  tabsOverall: {
    paddingBottom: "20px",
  },
  headerText: {
    fontSize: "36px",
    fontWeight: 700,
    marginBottom: "30px",
  },
  subHeading: {
    fontSize: "16px",
    fontWeight: 700,
    marginBottom: "50px",
  },
  mainText: {
    marginBottom: "10px",
  },
  subText: {
    marginBottom: "15px",
  },
  highlightText: {
    color: "#338F86",
    fontWeight: 800,
  },
  tabHeaderText: {
    marginTop: "20px",
  },

  list: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    marginTop: "24px",
  },
  unOrdered: {
    listStyleType: "none",
    padding: 0,
  },
  instruction: {
    marginLeft: "25px",
  },
  qrcode: {
    marginBottom: "10px",
    marginTop: "10px",
    marginLeft: "50px",
  },
  loader: {
    display: "flex",
    justifyContent: "left",
    marginLeft: "125px",
  },
  qrContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
  },
  qrcodeLuminor: {
    width: "20%",
  },
  qrImgTag: {
    maxWidth: "100%",
    maxHeight: "100%",
  },
  instructionContainer: {
    borderTop: "1px solid",
    marginTop: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "10px",
  },
  instructionHeader: {
    marginBottom: "10px",
  },
  instructionList: {
    li: {
      marginLeft: "21px",
      marginBottom: "10px",
    },
  },
}));
